import { useEffect } from 'react';
import PageHero from '@/components/PageHero';
import '../styles/about.css';

const MILESTONES = [
  {
    time: '第一步',
    title: '牛只档案与公开溯源',
    desc: '建立一牛一档的数据结构，耳标号可公开查询养殖履历，关键节点上链存证。',
  },
  {
    time: '第二步',
    title: '交易市场',
    desc: '上线挂牌、竞价、订单交割与资金托管，交易记录与牛只档案自动关联。',
  },
  {
    time: '第三步',
    title: '在途监管平台',
    desc: '接入 GPS 轨迹与电子围栏，运输过程对监管方与货主实时可见。',
  },
  {
    time: '第四步',
    title: '仓单质押与风控预警',
    desc: '基于存证档案生成电子仓单，支持动产融资登记与价格波动预警。',
  },
];

const VALUES = [
  { name: '数据留痕', desc: '关键操作必有记录，出了问题能查到具体人和时间' },
  { name: '贴合实际', desc: '按养殖与监管的真实流程设计，不要求用户改变既有习惯' },
  { name: '系统可用', desc: '不以演示效果为目标，优先保证日常业务跑得通' },
];

export default function About() {
  useEffect(() => {
    document.title = '关于我们 | 云牛集·山东牛产业智慧平台';
  }, []);

  return (
    <>
      <PageHero
        title="关于我们"
        desc="武汉高灏科技有限责任公司，负责云牛集平台的技术研发与运营。"
      />

      <section className="section">
        <div className="container">
          <div className="about-intro">
            <div className="about-intro-text">
              <h2>我们做的是一件具体的事</h2>
              <p>
                肉牛从出生到出栏，要经过育种、防疫、称重、交易、运输、屠宰多个环节，
                每一个环节的记录目前大多散落在纸面、微信和各自的系统里。
                云牛集把这些记录集中到一套系统：牛只建档后即生成唯一耳标，
                后续的防疫、称重、交易、运输都挂在同一份档案上，关键节点上链存证。
                这样监管方能核查、企业能追溯、消费者扫码就能看到这头牛经历过什么。
              </p>
            </div>
            <div className="mv-cards">
              <div className="mv-card">
                <span className="mv-label">我们做的事</span>
                <p>肉牛产业数字化系统的研发、部署与运营</p>
              </div>
              <div className="mv-card">
                <span className="mv-label">服务对象</span>
                <p>畜牧主管部门、养殖企业、屠宰加工与贸易企业、金融机构</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section alt">
        <div className="container">
          <div className="section-head">
            <h2>平台建设历程</h2>
            <p className="section-desc">以下为系统模块的上线顺序，均已交付可访问</p>
          </div>
          <ol className="milestone-list">
            {MILESTONES.map((m, i) => (
              <li key={m.time} className="milestone-item">
                <div className="milestone-dot" aria-hidden="true">
                  {i + 1}
                </div>
                <div className="milestone-body">
                  <span className="milestone-time">{m.time}</span>
                  <h3>{m.title}</h3>
                  <p>{m.desc}</p>
                </div>
              </li>
            ))}
          </ol>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="section-head">
            <h2>我们坚持的几件事</h2>
          </div>
          <ul className="value-list">
            {VALUES.map((v) => (
              <li key={v.name}>
                <strong>{v.name}</strong>
                <span>{v.desc}</span>
              </li>
            ))}
          </ul>
        </div>
      </section>
    </>
  );
}
